export function mapSortClause(node, ctx) {
    const expressions = [];
    const listNode = ctx.getChild(node, "SortExpressionList");
    if (listNode) {
        const items = ctx.getChildren(listNode, "SortExpressionItem");
        for (const item of items) {
            const exprNode = ctx.getChild(item, "Expression");
            const dirNode = ctx.getChild(item, "asc") ?? ctx.getChild(item, "desc");
            const nullsFirst = ctx.getChild(item, "first");
            const nullsLast = ctx.getChild(item, "last");
            expressions.push({
                type: "SortExpression",
                expression: exprNode
                    ? ctx.mapScalarExpression(exprNode)
                    : ctx.errorNode(item, "Missing sort expression"),
                direction: dirNode ? ctx.slice(dirNode) : undefined,
                nulls: nullsFirst ? "first" : nullsLast ? "last" : undefined,
                start: item.from,
                end: item.to,
            });
        }
    }
    return {
        type: "SortOperator",
        expressions,
        start: node.from,
        end: node.to,
    };
}
export function mapLimitClause(node, ctx) {
    const exprNode = ctx.getChild(node, "Expression");
    return {
        type: node.type.name === "LimitClause" ? "LimitOperator" : "TakeOperator",
        count: exprNode
            ? ctx.mapScalarExpression(exprNode)
            : ctx.errorNode(node, "Missing limit expression"),
        start: node.from,
        end: node.to,
    };
}
export function mapTopClause(node, ctx) {
    const exprNode = ctx.getChild(node, "Expression");
    const sortList = ctx.getChild(node, "SortExpressionList");
    const byExpressions = [];
    if (sortList) {
        const items = ctx.getChildren(sortList, "SortExpressionItem");
        for (const item of items) {
            const itemExpr = ctx.getChild(item, "Expression");
            const dirNode = ctx.getChild(item, "asc") ?? ctx.getChild(item, "desc");
            const nullsFirst = ctx.getChild(item, "first");
            const nullsLast = ctx.getChild(item, "last");
            byExpressions.push({
                type: "SortExpression",
                expression: itemExpr
                    ? ctx.mapScalarExpression(itemExpr)
                    : ctx.errorNode(item, "Missing sort expression"),
                direction: dirNode ? ctx.slice(dirNode) : undefined,
                nulls: nullsFirst ? "first" : nullsLast ? "last" : undefined,
                start: item.from,
                end: item.to,
            });
        }
    }
    return {
        type: "TopOperator",
        count: exprNode
            ? ctx.mapScalarExpression(exprNode)
            : ctx.errorNode(node, "Missing top count"),
        by: byExpressions,
        start: node.from,
        end: node.to,
    };
}
